import _defineProperty from "@babel/runtime/helpers/defineProperty";
var _ExpTemplateConfigurationFactory;
/* eslint-disable */
/**
 * Expression Service
 * An API for Expression services, supporting the Expression Editor and Expression Evaluation
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech) (v6.0.1).
 *
 * Do not edit the class manually.
 */

// InputSpec (yaml) file: /var/jenkins_home/workspace/V4-5-1-global-pipeline-all-web-products-build/webcommons/abweb/openapi/internal/typescript/target/openapi/openapi//abwebinternal/expressionservice.yaml
// Template file: models.mustache (typescript-fetch)

// @ts-ignore noUnusedLocals
import { ExpAdditionalDataFactory } from "./ExpAdditionalData";

/**
 * 
 * @export
 * @interface ExpTemplateConfiguration
 */

export class ExpTemplateConfigurationFactory {}
_ExpTemplateConfigurationFactory = ExpTemplateConfigurationFactory;
_defineProperty(ExpTemplateConfigurationFactory, "FromJSON", function (json) {
  return _ExpTemplateConfigurationFactory.FromJSONTyped(json, false);
});
_defineProperty(ExpTemplateConfigurationFactory, "FromJSONTyped", function (json, ignoreDiscriminator) {
  if (json === undefined || json === null) {
    return json;
  }
  return {
    'valueTypeID': json['valueTypeID'],
    'multiple': json['multiple'],
    'categoryID': json['categoryID'],
    'additionalData': json['additionalData'] === null || json['additionalData'] === undefined ? json['additionalData'] : ExpAdditionalDataFactory.FromJSON(json['additionalData'])
  };
});
_defineProperty(ExpTemplateConfigurationFactory, "ToJSON", function (value) {
  return _ExpTemplateConfigurationFactory.ToJSONTyped(false, value);
});
_defineProperty(ExpTemplateConfigurationFactory, "ToJSONTyped", function (ignoreDiscriminator, value) {
  if (value === undefined) {
    return undefined;
  }
  if (value === null) {
    return null;
  }
  return {
    'valueTypeID': value.valueTypeID,
    'multiple': value.multiple,
    'categoryID': value.categoryID,
    'additionalData': ExpAdditionalDataFactory.ToJSON(value.additionalData)
  };
});
//# sourceMappingURL=ExpTemplateConfiguration.js.map
